module.exports = __webpack_public_path__ + "static/media/t-shirt.b906502e.svg";